const WifiIcon = ({ color }: { color?: string }) => (
  <svg
    width="41"
    height="30"
    viewBox="0 0 41 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.2716 9.97352C40.0986 10.4221 39.8913 10.8457 39.4953 11.15C38.672 11.7825 37.618 11.8039 36.8192 11.1422C35.9965 10.4607 35.2509 9.69008 34.3975 9.04035C31.0822 6.51542 27.3661 4.97838 23.2255 4.49278C18.6654 3.95767 14.3179 4.69077 10.2049 6.74155C8.12544 7.77841 6.25493 9.11642 4.59076 10.74C4.25677 11.0661 3.90664 11.3683 3.45021 11.5142C2.51548 11.8133 1.49061 11.448 0.979998 10.6347C0.428745 9.75625 0.53191 8.6949 1.265 7.93211C1.909 7.26258 2.60875 6.65141 3.32986 6.06786C7.29283 2.86194 11.8045 0.874723 16.8553 0.240626C24.6354 -0.73631 31.61 1.2655 37.7352 6.17311C38.3177 6.63943 38.8487 7.16932 39.4077 7.66534C39.8121 8.02381 40.1163 8.44585 40.2721 8.96793C40.2716 9.30295 40.2716 9.63797 40.2716 9.97352Z"
      fill={color || "white"}
    />
    <path
      d="M20.4813 8.21977C25.616 8.29741 30.0625 10.0648 33.7514 13.6677C34.9123 14.8015 34.6778 16.5563 33.27 17.2279C32.4051 17.6406 31.5918 17.4869 30.8634 16.8679C30.3335 16.4177 29.839 15.929 29.2815 15.508C27.4808 14.1476 25.478 13.2227 23.2625 12.8346C18.5201 12.0035 14.3023 13.1399 10.6723 16.3427C10.479 16.5131 10.2878 16.6855 10.0934 16.8554C9.17954 17.6541 7.84101 17.6275 7.05789 16.796C6.21434 15.8998 6.24613 14.6092 7.14491 13.7078C9.16287 11.6846 11.5304 10.2132 14.2242 9.27226C16.2468 8.56574 18.3336 8.20779 20.4813 8.21977Z"
      fill={color || "white"}
    />
    <path
      d="M20.5637 16.3208C23.3919 16.3755 25.9137 17.3837 28.0176 19.4027C28.9424 20.29 29.0024 21.5556 28.175 22.4867C27.409 23.3485 26.0804 23.4319 25.1582 22.6107C24.1974 21.7547 23.1574 21.069 21.8809 20.8126C19.7379 20.3817 17.8142 20.846 16.1636 22.3002C15.5868 22.8082 14.9985 23.237 14.1779 23.1635C13.264 23.0822 12.6393 22.605 12.3189 21.7578C12.001 20.9163 12.1923 20.153 12.804 19.5106C13.5652 18.7103 14.4577 18.073 15.4331 17.5629C17.0123 16.7371 18.7036 16.3349 20.5637 16.3208Z"
      fill={color || "white"}
    />
    <path
      d="M17.5986 27.09C17.706 25.3826 18.9788 24.253 20.5138 24.2889C22.2582 24.3296 23.3795 25.6962 23.3248 27.2182C23.2633 28.9417 21.9321 30.0484 20.4054 29.9984C18.6386 29.9411 17.6242 28.5781 17.5986 27.09Z"
      fill={color || "white"}
    />
  </svg>
);

export default WifiIcon;
